import { render } from "./MultiselectLabels.vue?vue&type=template&id=23497f91"
import script from "./MultiselectLabels.vue?vue&type=script&lang=js"
export * from "./MultiselectLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__